import React, { useEffect, useState } from "react";
import {
    BrowserRouter ,
    Routes,
    Route
} from "react-router-dom";
import { Provider } from "react-redux";
import store from "../redux/store";

import Login from "../../pages/login/Login";
import Home from "../../pages/home/Home";
import Config from "../../pages/config/Config";
import Moenda from "../../pages/moenda/Moenda";
import Charts from "../../pages/moenda/charts/Charts";
import Notify from "../../components/Notify/Notify";
import LGPD from "../../pages/lgpd/LGPD";
import Privacy from "../../pages/privacy/Privacy";
import PassRetrieve from "../../pages/passRetrieve/PassRetrieve";
import WaitComponent from "../../components/Wait/Wait";
import Dashboard from "../../pages/dashboard/Dashboard";

const RoutesApp = () => {

    return <BrowserRouter>
            <Provider store={store}>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/inicio" element={<Home />} />
                <Route path="/privacidade" element={<Privacy />} />
                <Route path="/LGPD" element={<LGPD />} />
                {/* <Route path="/config" element={<Config />} /> */}
                <Route path="/moenda" element={<Moenda />} />
                <Route path="/charts" element={<Charts />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/senha-expirada" element={<PassRetrieve />} />
            </Routes>
            <Notify />
            <WaitComponent />
            </Provider>
    </BrowserRouter>
}

export default RoutesApp